import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IpService {

  private http = inject(HttpClient);

  getIp(): Observable<any> {
    return this.http.get('https://api.ipify.org/?format=json');
  }
}